<template>
  <div style="overflow-x:hidden;background: #7AC7FC" :style="viewStyle">
    <div class="header-bar">
      <v-img :src="images.new_logo" class="header-logo"></v-img>
      <v-img :src="images.title" class="header-title"></v-img>
      <v-img :src="images.school" class="header-school"></v-img>
      <v-img :src="images.icon_L1" class="header-icon" style="top: 300px; left: 4%"></v-img>
      <v-img :src="images.icon_L2" class="header-icon" style="top: 600px; left: 12%"></v-img>
      <v-img :src="images.icon_L3" class="header-icon" style="top: 900px; left: 0%"></v-img>
      <v-img :src="images.icon_L4" class="header-icon" style="top: 1200px; left: 8%"></v-img>
      <v-img :src="images.icon_R1" class="header-icon" style="top: 300px; right: 4%"></v-img>
      <v-img :src="images.icon_R2" class="header-icon" style="top: 600px; right: 0%"></v-img>
      <v-img :src="images.icon_R3" class="header-icon" style="top: 900px; right: 12%"></v-img>
      <v-img :src="images.icon_R4" class="header-icon" style="top: 1200px; right: 5%"></v-img>
    </div>
    <div class="ma-0">
      <v-row class="mx-0 mt-6" style="width:100%; height:100%; align-items: center;" justify="center">
        <v-col class="col-12 col-sm-10 col-md-8" style="display: flex; justify-content: center"> 
          <div id="box2" class="px-2 py-12">
            <v-row class="ma-0" justify="center">
              <v-col class="py-0 col-12 col-sm-11 col-md-9">
                <v-row class="ma-0 DarkBlue" justify="center" style="align-items: center">
                  <div style="flex:1; height:2px; background:#000; margin:0"></div>
                  <h1 class="title-text">國高中招生報名系統</h1>
                  <div style="flex:1; height:2px; background:#000; margin:0"></div>
                </v-row>
                <v-row class="ma-0" justify="center">
                  <v-row class="mx-0 my-5 DarkBlue" style="max-width:fit-content; border-radius:100px; background:#E5EEFA">
                    <v-btn :class="selected === '2' ? 'select-btn' : 'select-btn-outline'" outlined @click="selected = '2'">
                      <span :style="{ color: selected === '2' ? '#FFFFFF' : '#002C61' }">
                        高中部
                      </span>
                    </v-btn>
                    <v-btn :class="selected === '1' ? 'select-btn' : 'select-btn-outline'" outlined @click="selected = '1'">
                      <span :style="{ color: selected === '1' ? '#FFFFFF' : '#002C61' }">
                        國中部
                      </span>
                    </v-btn>
                  </v-row>
                </v-row>
                <v-row class="mx-0 my-2 pa-2" justify="center" style="background:#E8E8E8; color:#000">
                  <h4 class="remind">一切資料請據實填報，若有不實，本校可取消錄取資格。</h4>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>國籍</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-radio-group class="ma-0 pa-0" dense v-model="datasets.citizenShip">
                      <v-row class="ma-0 py-1">
                        <v-radio class="pr-2" value="1" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">臺灣</span>
                          </template>
                        </v-radio>
                        <v-radio class="pr-2" value="2" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">非臺灣</span>
                          </template>
                        </v-radio>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>身份證字號</div>
                  </v-col>
                  <v-col class="pa-1 col-9">
                    <v-text-field class="text_field border" dense outlined placeholder="請輸入身份證或護照號碼" maxlength="20" v-model="datasets.idCard"
                    @keyup="datasets.idCard = datasets.idCard.replace(/[\u4e00-\u9fa5]/ig,'') && datasets.idCard.toUpperCase(), datasets.idCard = $Global.toCDB(datasets.idCard)"></v-text-field>
                  </v-col>
                  <v-col class="pa-0 pt-1 text-left col-1">
                    <v-icon v-if="isIdCardOk" color="#81E285" size="30">mdi-check-all</v-icon>
                    <v-icon v-else color="#E28181" size="30">mdi-close</v-icon>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>性別</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-radio-group class="ma-0 pa-0" dense v-model="datasets.gender">
                      <v-row class="ma-0 py-1">
                        <v-radio class="pr-2" value="1" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">男性</span>
                          </template>
                        </v-radio>
                        <v-radio class="pr-2" value="0" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">女性</span>
                          </template>
                        </v-radio>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>學生姓名</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-text-field class="text_field" dense outlined placeholder="請輸入學生姓名" maxlength="20" v-model="datasets.name"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>出生年月日</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-text-field class="text_field" type="tel" dense outlined placeholder="ex:1000101" maxlength="7"
                    @keypress="onlyNumber" @input="datasets.birthday = datasets.birthday.replace(/[^0-9]/g, '')" v-model="datasets.birthday"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="selected === '2'" class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>身份</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-radio-group class="ma-0 pa-0" dense v-model="datasets.identityType">
                      <v-row class="ma-0 py-1">
                        <v-radio class="pr-2" value="1" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">應屆</span>
                          </template>
                        </v-radio>
                        <v-radio class="pr-2" value="0" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">非應屆</span>
                          </template>
                        </v-radio>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>畢業學校</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-row class="ma-0">
                      <v-select class="border pt14 pr-2" dense outlined placeholder="請選擇縣市" style="width:50%"
                      :items="countryList" v-model="datasets.graduatedSchoolArea"></v-select>
                      <v-text-field v-if="datasets.graduatedSchoolArea == '其他'" class="text_field" dense outlined placeholder="請輸入學校名稱" style="width:50%" v-model="datasets.graduatedSchool"></v-text-field>
                      <v-select v-else class="border pt14" dense outlined placeholder="請選擇學校名稱" style="width:50%"
                      :items="schoolList" v-model="datasets.graduatedSchool"></v-select>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-if="selected === '2'" class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>報名科別</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-select class="border pt14" dense outlined placeholder="請選擇報名科別" style="width:100%"
                    :items="categoryList" item-text="name" item-value="name" v-model="datasets.category"></v-select>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>電話1/關係</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-row class="ma-0">
                      <v-text-field class="text_field pr-2" dense outlined placeholder="請輸入電話" maxlength="50" v-model="datasets.tel1"></v-text-field>
                      <v-text-field class="text_field" dense outlined placeholder="請輸入關係" maxlength="20" v-model="datasets.tel1Relation"></v-text-field>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="whiteTitle"></span>電話2/關係</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-row class="ma-0">
                      <v-text-field class="text_field pr-2" dense outlined placeholder="請輸入電話" maxlength="50" v-model="datasets.tel2"></v-text-field>
                      <v-text-field class="text_field" dense outlined placeholder="請輸入關係" maxlength="20" v-model="datasets.tel2Relation"></v-text-field>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>地址</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-row class="ma-0">
                      <v-text-field class="text_field pr-2" dense outlined placeholder="郵遞區號" maxlength="5" style="width:20%" v-model="datasets.zipCode"></v-text-field>
                      <v-text-field class="text_field" dense outlined placeholder="請輸入詳細地址" maxlength="100" style="width:70%" v-model="datasets.address"></v-text-field>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="pa-1 submenu" style="width:10%" @click="openPostLink()" 
                          v-bind="attrs" v-on="on">
                            <v-icon color="#525252">mdi-information-variant-circle</v-icon>
                          </div>
                        </template>
                        <span>點此查詢郵遞區號</span>
                      </v-tooltip>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>家長姓名</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-text-field class="text_field" dense outlined placeholder="請輸入家長姓名" maxlength="20" v-model="datasets.parentName"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="whiteTitle"></span>本校輔導老師</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-select class="border pt14 select-clear-padding" dense outlined clearable placeholder="請選擇本校輔導老師" style="width:100%"
                    :items="mentorList" v-model="datasets.counselorName"></v-select>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="pa-1 col-2">
                    <div class="text-left pt-2 pt14"><span class="whiteTitle"></span>本校推薦學生/其他</div>
                  </v-col>
                  <v-col class="pa-1 col-10">
                    <v-radio-group class="ma-0 pa-0" dense v-model="datasets.recommend">
                      <v-row class="ma-0 py-1">
                        <v-radio class="pr-2" value="1" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">在校生</span>
                          </template>
                        </v-radio>
                        <v-radio class="pr-2" value="2" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">兄弟姊妹</span>
                          </template>
                        </v-radio>
                        <v-radio class="pr-2" value="0" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">無</span>
                          </template>
                        </v-radio>
                        <v-radio class="pr-2" value="3" color="#002C61">
                          <template v-slot:label>
                            <span class="pt14" style="color:#000000">其他</span>
                          </template>
                        </v-radio>
                      </v-row>
                    </v-radio-group>
                    <v-row class="ma-0">
                      <v-text-field class="text_field pr-2" dense outlined placeholder="請輸入姓名" maxlength="20" v-model="datasets.recommendStudent"></v-text-field>
                      <v-text-field class="text_field" dense outlined placeholder="請輸入班級" maxlength="20" v-model="datasets.recommendClass"></v-text-field>
                    </v-row>
                  </v-col>
                </v-row>
                <VueLoadingButton aria-label="Post message" class="ma-3 search-bar-btn"
                  @click.native="checkInformation()" :loading="isLoading">
                  <span class="pr-2" style="color:#FFFFFF">送出報名資訊</span>
                  <v-icon color="#FFF">mdi-cursor-default-click</v-icon>
                </VueLoadingButton>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0" justify="center">
        <h4 class="mb-4 pt14" style="color:#FFF">Copyright©2025 東泰高級中學</h4>
      </v-row>
    </div>
    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
    <SuccessInfo ref="SuccessInfo" :onSave="onSuccessInfo"/>
  </div>
</template>

<script>
import VueLoadingButton from 'vue-loading-button';
import ShowMsg from '@/dialogs/ShowMsg'
import SuccessInfo from '@/dialogs/SuccessInfo'

export default {
  name: 'Registration',
  components: {VueLoadingButton,ShowMsg,SuccessInfo},
  mounted(){
    this.calculateWindows()
    window.onresize = () => {
      this.calculateWindows()
    }
    this.$Global.getCategoryList().then(res=>{ this.categoryList = res })
    this.$Global.getYear().then(res=>{ this.datasets.year = res})
    this.getCountryList()
    this.getMentorList()
  },
  data:()=>({
    viewStyle:{},
    images:{
      new_logo: require('@/assets/image/logo.png'),
      title: require('@/assets/image/title.png'),
      school: require('@/assets/image/school.png'),
      icon_L1: require('@/assets/image/icon_L1.png'),
      icon_L2: require('@/assets/image/icon_L2.png'),
      icon_L3: require('@/assets/image/icon_L3.png'),
      icon_L4: require('@/assets/image/icon_L4.png'),
      icon_R1: require('@/assets/image/icon_R1.png'),
      icon_R2: require('@/assets/image/icon_R2.png'),
      icon_R3: require('@/assets/image/icon_R3.png'),
      icon_R4: require('@/assets/image/icon_R4.png'),
    },
    selected: '2', //2-高中部 1-國中部
    datasets:{
      year: '',
      citizenShip: '1',
      idCard: '',
      gender: '',
      identityType: '1',
      graduatedSchoolArea: '',
      graduatedSchool: '',
      recommend: '0',
    },
    isIdCardOk:false,
    countryList: [],
    schoolList: [],
    categoryList: [],
    mentorList: [],

    isLoading: false,
    requiredField:['citizenShip','idCard','gender','name','birthday','tel1','tel1Relation','zipCode','address','parentName','graduatedSchoolArea','graduatedSchool'],
    requiredField2:['identityType','category'],
  }),
  watch:{
    "datasets.counselorName":function(){
      if(this.datasets.counselorName === null || this.datasets.counselorName === undefined ) {
        this.datasets.counselorName = ''
      }
    },
    "selected":function(){
      this.getCountryList()
    },
    "datasets.graduatedSchoolArea":function(){
      if(this.datasets.graduatedSchoolArea == '其他'){
        this.datasets.graduatedSchool = ''
      }else{
        this.getSchoolList(this.datasets.graduatedSchoolArea)
      }
    },
    "datasets.citizenShip":function(){
      this.datasets.idCard = ''
    },
    "datasets.idCard":function(){
      this.datasets.gender = ''
      if(this.datasets.citizenShip == '1'){
        if(this.datasets.idCard.length == 10){
          this.datasets.idCard = this.datasets.idCard.toUpperCase();
          this.$Global.checkIdCard(this.datasets.idCard).then(res=>{ 
            if(res.isIdCardVaild == 'Success'){
              if (this.datasets.idCard && this.datasets.idCard.length >= 2) {
                const g = this.datasets.idCard[1];
                this.datasets.gender = g === '1' ? '1' : g === '2' ? '0' : ''
              }
              this.isIdCardOk = true
            }else if(res.isIdCardVaild == 'Validation failed: You have already completed the registration.'){ //身份證已經報名過
              this.$refs.ShowMsg.open(0,' 系統提示','該身份證字號已經完成報名，無需重複填寫。若有疑問請洽本校輔導老師，感謝')
              this.isIdCardOk = true
            }else{  //身份證在黑名單或身份證錯誤
              console.log(res.isIdCardVaild)
              this.$refs.ShowMsg.open(0,' 系統提示','身份證字號驗證錯誤，請重新確認。若有疑問請洽本校輔導老師或招生專線 (03)5961232')
              this.isIdCardOk = false
            }
          })
          return
        }
        this.isIdCardOk = false
      }
      if(this.datasets.citizenShip == '2'){
        if(this.datasets.idCard.length > 5 && this.datasets.idCard.length <= 20){
          this.$Global.checkPassport(this.datasets.idCard).then(res=>{ 
            if(res.isIdCardVaild == 'Success'){
              this.isIdCardOk = true
            }else if(res.isIdCardVaild == 'Validation failed: You have already completed the registration.'){ //身份證已經報名過
              this.$refs.ShowMsg.open(0,' 系統提示','該身份證字號已經完成報名，無需重複填寫。若有疑問請洽本校輔導老師，感謝')
              this.isIdCardOk = true
            }else{
              console.log(res.isIdCardVaild)
              this.$refs.ShowMsg.open(0,' 系統提示','身份證字號驗證錯誤，請重新確認。若有疑問請洽本校輔導老師或招生專線 (03)5961232')
              this.isIdCardOk = false
            }
          })
          return
        }
        this.isIdCardOk = false
      }
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    onlyNumber (e) {
      const char = String.fromCharCode(e.keyCode)
      // 若不是 0–9，阻止輸入
      if (!/[0-9]/.test(char)) {
        e.preventDefault()
      }
    },
    openPostLink(){
      window.open("https://www.post.gov.tw/post/internet/Postal/index.jsp?ID=208", "_blank");
    },
    getCountryList(){
      this.datasets.identityType = '1'
      this.datasets.graduatedSchoolArea = '新竹縣'
      this.getSchoolList(this.datasets.graduatedSchoolArea)
      this.datasets.graduatedSchool = ''
      this.datasets.category = ''
      var self = this
      var request = {
        method: 'GET',
        url: '/common/countryListByCategory',
        params: {
          'category': this.selected,
        },
      }
      this.$http(request).then(function(response) {
        self.countryList = response.data.data
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為Reg-7964')
      })
    },
    getSchoolList(country){
      var self = this
      var request = {
        method: 'GET',
        url: '/common/schoolList',
        params: {
          'category': this.selected,
          'country': country,
        },
      }
      this.$http(request).then(function(response) {
        self.schoolList = response.data.data
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為Reg-7964')
      })
    },
    getMentorList(){
      var self = this
      var request = {
        method: 'GET',
        url: '/common/mentorList',
        params: {},
      }
      this.$http(request).then(function(response) {
        self.mentorList = response.data.data
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為Reg-7964')
      })
    },

    checkInformation(){
      if(!this.isIdCardOk){
        this.$refs.ShowMsg.open(0,' 系統提示','身份證字號驗證錯誤，請重新確認。若有疑問請洽本校輔導老師或招生專線 (03)5961232')
        return
      }
      if(!this.$Global.checkForm(this.datasets,this.requiredField)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(this.selected == '2'){ //2-高中部
        if(!this.$Global.checkForm(this.datasets,this.requiredField2)){
          this.$refs.ShowMsg.open(1)
          return
        }
      }
      this.newDataset()
    },
    newDataset() {
      this.isLoading = true
      var allData = this.$Global.copy( this.datasets )
      allData = this.$Global.jsonConcat(allData,{'applicationChannel' : '1'})
      allData = this.$Global.jsonConcat(allData,{'schoolType' : this.selected})
      var self = this
      var request = {
        method: 'POST',
        url: '/common/studentProfile',
        data: this.Qs.stringify(allData)
      }
      this.$http(request).then(function(response) {
        self.isLoading = false
        if(response.data.msg =='成功'){
          if(self.datasets.identityType == '0'){
            self.$refs.SuccessInfo.open(2,'','',true)
          } else{
            self.$refs.SuccessInfo.open(1,'','',true)
          }
        }else if (response.data.msg =='重複報名'){
          self.$refs.SuccessInfo.open(0,'系統提示','該身份證字號已經完成報名，無需重複填寫。若有疑問請洽本校輔導老師，感謝',true)
        }else{
          self.$refs.SuccessInfo.open(0,'系統提示',response.data.msg)
        }
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Reg-7965')
        self.isLoading = false
      })
    },
    onShowMsg(){
      window.location.reload()
    },
    onSuccessInfo(){
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.header-bar {
  position: relative;
  width: 100%;
  height: 210px;
}

.header-logo {
  position: absolute;
  top: 20px;
  left: 20px;
  max-width: 280px;
  width: 30%;
  min-width: 120px;
}

.header-title {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 760px;
  width: 50%;
  min-width: 120px;
}

.header-school {
  position: absolute;
  top: 0px;
  right: 0px;
  max-width: 360px;
  width: 28%;
  min-width: 120px;
}

.header-icon {
  position: absolute;
}

@media (max-width: 960px) {
  .header-logo {
    max-width: 340px;
    width: 50%;
  }
  .header-title {
    top: 60px;
    width: 160%;
  }
  .header-school {
    display: none
  }
}
</style>